<!--角色权限表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form class="role-permission-search-form" @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="roleTypeCode"
          style="width: 100%"
          :value.sync="queryParams.roleTypeCode"
          :selectData="roleList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
        />
        <a-select slot="enableExceptionRemark" v-model="queryParams.enableExceptionRemark" allowClear>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
        <global-select
          slot="supplierCodeList"
          ref="supplierCodeListRef"
          :value.sync="queryParams.supplierCodeList"
          :dropdown-match-select-width="false"
          selectType="selectMultipleSearch"
          requestApi="/mdm/mdmOrgSupplier/supplierNameList"
          :selectItem="{ value: 'label', label: 'realValue' }"
          searchParam="supplierName"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiRoleExportRoleUserList" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
        <a-button type="primary" @click="handleAdd">新增</a-button>
        <addRoleModal ref="addRoleModalRef" :roleList='roleList' @refreshFun="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <!-- 姓名 -->
          <template slot="userName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.userName" placeholder="请输入" :maxLength="50" />
          </template>
          <!-- 供应商 -->
          <template slot="supplierName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="supplier-css"
              :allowClear="false"
              ref="supplierCodeRef"
              :value.sync="record.supplierName"
              :dropdown-match-select-width="false"
              selectType="selectSearch"
              requestApi="/mdm/mdmOrgSupplier/supplierNameList"
              :selectItem="{ value: 'realValue', label: 'realValue' }"
              searchParam="supplierName"
              @change="(val, data)=>supplierChange(val, data, record)"
            />
          </template>
          <!-- 角色 -->
          <template slot="roleTypeCodeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              style="width: 100%"
              :allowClear="false"
              :value.sync="record.roleTypeCode"
              :selectData="roleList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </template>
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <!-- 电话 -->
          <template slot="userTel" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.userTel" placeholder="请输入" :maxLength="50" />
          </template>
          <!-- 是否生效 -->
          <template slot="isEnableName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-select v-else slot="isEnableName" v-model="record.isEnable">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </template>
          <!-- 可否操作异常备注 -->
          <template slot="enableExceptionRemarkName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-select v-else v-model="record.enableExceptionRemark" :allowClear="false">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import cacheRequest from '@/mixins/cacheRequest'
import addRoleModal from './components/addRoleModal'
import { apiInvHandoverMonitorDetailExport } from '@/api/report/Handover-monitoring'
import {
  apiRoleExportRoleUserList,
  apiGetRoleUserList,
  apiRoleSaveOrUpdate
} from '@/api/scp/materialReservationManagement/materialReservation'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { mapState } from 'vuex'

export default {
  name: 'RolePermissionList',
  mixins: [cacheRequest],
  components: { addRoleModal, DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      apiRoleExportRoleUserList,
      roleList: [], // 角色列表
      apiInvHandoverMonitorDetailExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetRoleUserList, false),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 查询参数
      queryParams: {
        organizationNo: undefined,
        organizationName: undefined,
        roleTypeCode: undefined,
        userName: undefined,
        userTel: undefined,
        enableExceptionRemark: undefined,
        supplierCodeList: undefined
      },
      formList: [
        { label: '组织编码', decorator: ['organizationNo'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '组织名称', decorator: ['organizationName'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '角色', decorator: ['roleTypeCode'], type: 'roleTypeCode' },
        { label: '姓名', decorator: ['userName'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '电话', decorator: ['userTel'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '可否操作异常备注', decorator: ['enableExceptionRemark'], type: 'enableExceptionRemark' },
        { label: '材料商名称', decorator: ['supplierCodeList'], type: 'supplierCodeList' }
      ],
      // 表格字段
      columns: [
        { title: '组织编码', dataIndex: 'organizationNo', align: 'center', width: 100 },
        { title: '组织名称', dataIndex: 'organizationName', align: 'center', width: 140 },
        { title: '材料商编码', dataIndex: 'supplierCode', align: 'center', width: 100 },
        { title: '材料商名称', dataIndex: 'supplierName', scopedSlots: { customRender: 'supplierName' }, align: 'center', width: 180 },
        { title: '角色', dataIndex: 'roleTypeCodeName', scopedSlots: { customRender: 'roleTypeCodeName' }, align: 'center', width: 120 },
        { title: '姓名', dataIndex: 'userName', align: 'center', scopedSlots: { customRender: 'userName' }, width: 120 },
        { title: '电话', dataIndex: 'userTel', scopedSlots: { customRender: 'userTel' }, align: 'center', width: 140 },
        { title: '是否生效', dataIndex: 'isEnableName', scopedSlots: { customRender: 'isEnableName' }, align: 'center', width: 100 },
        { title: '可否操作异常备注', dataIndex: 'enableExceptionRemarkName', scopedSlots: { customRender: 'enableExceptionRemarkName' }, align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 80 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 80 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('MINI_PROGRAM_ROLE_TYPE', { lookupType: 'MINI_PROGRAM_ROLE_TYPE', current: 1, pageSize: 999 }, 'roleList')
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 材料商选择回调
    supplierChange(val, data, record) {
      if(val) {
        const getSupplier = data?.find(item => item?.realValue === val)
        record.supplierCode = getSupplier?.label
      } else {
        record.supplierCode = ''
      }
    },
    // 保存后刷新，不翻页
    onFreshSearch() {
      this.handleOk(true)
    },
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      if(!record?.userTel) {
        this.$message.warning('请输入电话')
        return;
      }
      if(!record?.userName) {
        this.$message.warning('请输入姓名')
        return;
      }
      this.loading = true;
      apiRoleSaveOrUpdate(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('编辑成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增
    handleAdd() {
      this.$refs.addRoleModalRef.show()
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      params.desOrganizationCode = this.organizationCodeOrigin // 当前组织
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationNo: undefined,
        organizationName: undefined,
        roleTypeCode: undefined,
        userName: undefined,
        userTel: undefined,
        enableExceptionRemark: undefined,
        supplierCodeList: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      if(this.$refs?.supplierCodeListRef) {
        this.$refs.supplierCodeListRef.handleSearch("")
      }
    }
  }
}
</script>

<style scoped lang="less">
.supplier-css{
  /deep/ .ant-select-selection{
    width: 180px;
  }
}
/deep/.role-permission-search-form .ant-col:nth-last-child(3) {
  .ant-form-item{
    .ant-form-item-label{
      width: 150px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 240px !important;
    }
  }
}
</style>
